import KendoCell from './KendoCell'

export default KendoCell
